import React from 'react'
import useDashboardApi from '../../../../hooks/useDashboardApi'
import { LoadingButton, LoadingComponent } from 'usbc-web-react-library'
import OrderForm from '../../../shared/OrderForm/OrderForm';


function OrderEditForm(props) {

    const {
        saveOrder,
        loading: saveOrderLoading,
    } = useDashboardApi();

    const {
        getNewOrderDetails,
        response: order,
        setResponse: setOrder,
        loading: getNewOrderDetailsLoading,
    } = useDashboardApi();
    const {
        getOrderDetails,
        response: existingOrder,
        setResponse: setexistingOrder,
        loading: getOrderDetailsLoading,
    } = useDashboardApi();

    React.useEffect(() => {
        if (!!props.order) {
            let body = {
                orderId: props.order.id
            };
            if (body.orderId && body.orderId !="null") {
                getOrderDetails(body);
            }
            else
                getNewOrderDetails(body).then((order) => {
                });
        }
    }, [props.order]);

    function onValidOrderSubmitted(order) {
        saveOrder(order).then((result) => {
            if (result) {
                props.onOrderSaved();
            }
        });
    }

    function cancelHandler() {
        setOrder({});
        props.onCancel();
    }
    return (
        <LoadingComponent isLoading={() => getNewOrderDetailsLoading || getOrderDetailsLoading} description="Loading Order Info" >
            {(order != null || existingOrder != null) &&
                <>
                    <OrderForm order={order ?? existingOrder} onValidOrderSubmitted={onValidOrderSubmitted} readOnly={props.order?.id && props.order.id !="null"} />
                    <div className='row mt-3 pt-3 border-top'>
                        <div className="col-12">
                            <div className="d-flex justify-content-between">
                                <button className="btn btn-primary bowl-btn" type="button" onClick={cancelHandler}
                                    disabled={saveOrderLoading}>
                                    <i className="bi bi-arrow-left-square"></i>
                                    <span className='ms-2'> Cancel</span>
                                </button>
                                <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                                    <LoadingButton type="submit" form='orderInfo-form' className="btn btn-success bg-usbc-green me-md-1" loadingText='Saving...'
                                        disabled={props.order?.id && props.order.id !="null"}
                                        loading={saveOrderLoading}>
                                        <i className="bi bi-save"></i>
                                        <span className='ms-2'> Save</span>
                                    </LoadingButton>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            }
        </LoadingComponent>
    )
};

export default OrderEditForm;

